<template>
  <div :class="btnClass" @click="onClick">
    <span class="title">{{ title }}</span>
  </div>
</template>
<script>
export default {
  name: "GradientButton",
  props: {
    title: {
      type: String,
      isRequired: true,
    },
    className: {
      type: String,
      default: "",
    },
    isActive: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    btnClass() {
      const inactive = this.isActive ? "" : " inactive";
      if (this.className) {
        return (
          "gradient-button-container normal-button" + this.className + inactive
        );
      } else {
        return "gradient-button-container normal-button" + inactive;
      }
    },
  },
  methods: {
    onClick() {
      if (!this.isActive) return;
      this.$emit("onClick");
    },
  },
};
</script>
<style lang="scss" scoped>
.gradient-button-container {
  background-color: #2e2323;
  height: 50px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  .title {
    color: white;
    font-size: 16px;
    font-weight: 700;
  }
}
.inactive {
  background-image: none;
  background-color: #aaaaaa;

  &:hover {
    opacity: 1;
  }
}
</style>